<template>
    <div class="flex flex-col h-screen bg-muted">
        <Topbar />

        <UProgress v-if="appStore.isLoaderActive()" size="xs" class="absolute top-14 inset-x-0" />

        <main class="flex-1 overflow-auto p-4">
            <router-view />
        </main>
    </div>
</template>

<script lang="ts" setup>
    import Topbar from '@/layouts/components/Topbar.vue'
    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()
</script>
